var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProTitle = function SvgProTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#proTitle_svg__a)",
    d: "M28.145 14.88c-4.008 0-5.976-2.544-5.232-6.696.6-3.48 3.096-5.496 6.624-5.496 3.936 0 5.904 2.496 5.208 6.696-.648 3.456-3.144 5.496-6.6 5.496m1.056-8.808c-1.368 0-2.016.912-2.304 2.544-.312 1.848.048 2.832 1.56 2.832 1.368 0 2.016-.864 2.304-2.52.312-1.824-.048-2.856-1.56-2.856"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#proTitle_svg__b)",
    d: "m19.355 3.048-.696 4.032.288.024c1.392-3.768 2.424-4.176 3.744-4.176h.288l-.84 4.704h-.768c-2.16 0-2.664.48-2.952 2.136l-.84 4.752h-4.08l2.016-11.472z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#proTitle_svg__c)",
    d: "M7.272 10.944H4.944L4.32 14.52H0L2.544.12H8.28c4.248 0 6.144 2.28 5.496 5.952-.504 3-2.856 4.872-6.504 4.872m.48-7.2H6.216L5.568 7.44H7.2c1.512 0 2.184-.48 2.4-1.656.216-1.32-.312-2.04-1.848-2.04"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "proTitle_svg__a",
    x1: 61.116,
    x2: -25.346,
    y1: 3.184,
    y2: 14.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB8B44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "proTitle_svg__b",
    x1: 61.116,
    x2: -25.346,
    y1: 3.184,
    y2: 14.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB8B44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "proTitle_svg__c",
    x1: 61.116,
    x2: -25.346,
    y1: 3.184,
    y2: 14.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB8B44"
  })))));
};
export default SvgProTitle;